{
  "a": "a",
  "an": "an",
  "Account": "Account",
  "AccountSettings": "Account Settings",
  "changeAccountSettings": "Change your basic account settings",
  "notVerified": "Not verified",
  "Verified": "Verified",
  "AlternateEmail": "Alternative Email",
  "NoAlternateEmail": "You have no alternative emails.",
  "changeRole": "change role",
  "LeaveProject": "Leave Project",
  "NoActionPhrase1": "There aren't any actions you can take on yourself. To make edits, see your",
  "accountSettings": "account settings",
  "NoActionPhrase2": "There aren't any actions for you to take on ",
  "save": "Save",
  "Title": "Title",
  "editTitle": "edit title",
  "DangerZone": "Danger Zone",
  "Delete": "Delete ",
  "DeleteWarning": "Once you delete this project, there is NO going back. Please be certain.",
  "DeleteProjectButton": "Delete this project",
  "Hub": "Hub",
  "Project": "Project",
  "ManageTeam": "Manage Team",
  "Team": "Team",
  "ManageTeamPhrase1Part1": "You are ",
  "ManageTeamPhrase1Part2": " of this project.",
  "ManageTeamPhrase2Part1": " To add a team member, ",
  "clickHere": " click here",
  "PendingInvitations": "Pending Invitations",
  "resendInvite": "Resend Invite",
  "NoPendingInvitations": "No pending invitations",
  "Primary": "Primary",
  "verify": "Verify",
  "MakePrimary": "Make primary",
  "remove": "Remove",
  "EmailAddress": "Email Address",
  "addEmail": "Add email",
  "addHubAdmin": "To add a hub admin,",
  "ProjectNameAlreadyExists": "Shoot! This project name is already in use. Please select another name. But hey, it's another chance to be creative!",
  "ConfirmProjectDeletion": "Are you sure you want do delete this Project?",
  "SubscriptionExpired": "Your Subscription has Expired",
  "SubscriptionExpiredMessage": "Your access to hub is now limited. Please renew by contacting us.",
  "FirstChoice": "Contact Us",
  "Cancel": "Cancel",
  "firstName": "First Name",
  "lastName": "Last Name",
  "Purpose": "Purpose",
  "Location": "Location",
  "LocationPlaceholder": "Search for your city here",
  "Stage": "Stage",
  "Seed": "Seed",
  "Planning": "Planning",
  "Startup": "Startup",
  "Growth": "Growth",
  "Mature": "Mature",
  "noTitle": "no title yet",
  "Name": "Name",
  "Role": "Role",
  "DeleteAccountHeading": "Delete your account",
  "DeleteAccountButton": "Delete account",
  "DeleteAccountWarning": "Deleting your account signs you out everywhere straight away. After 30 days we permanently erase your personal information — your name, email addresses, profile, uploaded images and activity logs. This cannot be undone.",
  "DeleteAccountDialogTitle": "Delete your account?",
  "DeleteAccountDialogWarning": "Your account will be deactivated immediately and permanently erased after 30 days. Contact support@rebelbase.co before then if you change your mind.",
  "DeleteAccountConfirmPrompt": "Type {{confirmation}} to confirm.",
  "DeleteAccountConfirmButton": "Delete my account",
  "DeleteAccountError": "We could not process that request. Please try again, or contact support@rebelbase.co.",
  "Profile": "Profile",
  "NameRequired": "This field is required.",
  "ProjectIdentityTitle": "Project identity",
  "ProjectIdentityDescription": "How your project is introduced across RebelBase — in search, invitations and team dashboards.",
  "Replace": "Replace",
  "LogoHint": "JPG, PNG or GIF, up to 5 MB.",
  "ProjectDetailsTitle": "Project details",
  "ProjectDetailsDescription": "Your project's industry, stage and search visibility.",
  "GeneralTab": "General",
  "MembersAndRolesTab": "Members & roles",
  "ProjectSettingsTabsLabel": "Project settings sections",
  "NoChangesYet": "No changes yet",
  "UnsavedChanges": "Unsaved changes",
  "AllChangesSaved": "All changes saved",
  "SaveChanges": "Save changes",
  "MaxPhotoSize": "Great photo but it exceeded the max size: 5mb.",
  "SupportedFormats": "Image format not supported. Supported formats are jpg, jpeg, png, gif and jfif.",
  "memberActions": "Member actions",
  "RemoveFromProject": "Remove from project",
  "RemoveMemberDialogTitle": "Remove member",
  "RemoveMemberDialogWarning": "{{name}} will lose access to this project immediately. Anything they wrote stays with the project.",
  "RemoveMemberPeerHint": "You cannot remove a member at your own role level or above.",
  "RemoveMemberOwnerHint": "Owners cannot be removed. Give them a lower role first.",
  "MemberRemoved": "{{name}} was removed from the project.",
  "MemberRemovedGroups": "The project also left: {{groups}}.",
  "RemoveMemberError": "That member could not be removed. Please try again.",
  "LeaveProjectDialogTitle": "Leave project",
  "LeaveProjectDialogWarning": "You will lose access to this project immediately.",
  "LeaveProjectLastMemberHint": "You are the only member, so you cannot leave. Delete the project instead.",
  "leave": "Leave",
  "RemoveMemberConfirm": "Remove",
  "AccountSettingsSubtitle": "Manage your name, sign-in and email notifications.",
  "AccountSettingsTabsLabel": "Account settings sections",
  "NotificationsTab": "Notifications",
  "PrivacyTab": "Privacy",
  "ProfileSectionDescription": "Your name and where you are based.",
  "PublicProfileLink": "Photo and bio live on your public profile",
  "SocialLinksDescription": "Show your LinkedIn, Twitter or Facebook on your public profile.",
  "EmailAddressDescription": "Where we reach you. Changes here apply immediately.",
  "RemoveEmailDialogTitle": "Remove this email address?",
  "RemoveEmailDialogWarning": "You will stop receiving mail at {{email}}. You can add it again later, but it will need verifying from scratch.",
  "RemoveEmailConfirmButton": "Remove email",
  "DangerZoneDescription": "Deleting your account is permanent once the 30-day grace period ends.",
  "EmailNotificationsDescription": "How often we email you a digest of what has happened."
}
